import { api } from "@services/baseURL";

export const SaveRelatorioSharepoint = async (formData) => {
  try {
    const response = await api.post(
      `Relatorio/upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      `Erro ao salvar relatório para o processo de id: ${formData.idProcesso}:`,
      error
    );
    throw error;
  }
};

export const DeleteRelatorio = async (id) => {
  try {
    await api.delete(`Relatorio/${id}`);
    return true;
  } catch (error) {
    console.error('Erro ao deletar relatorio:', error);
    throw error;
  }
};

export const GetAllRelatorios = async (pageSize, rowsPerPage) => {
  try {
    const response = await api.get('Relatorio', {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos os relatórios:', error);
    throw error;
  }
};

export const GetAllRelatoriosByIdProcessoAndIdUnidadeGerencia = async (
  pageSize, 
  rowsPerPage, 
  idProcesso, 
  idUnidadeGerencia) => {

  try {
    const response = await api.get(`Relatorio/${idProcesso}/${idUnidadeGerencia}`, {
      headers: {
        Authorization: `Bearer authToken`,
      },
      params: {
        pageNumber: pageSize,
        pageSize: rowsPerPage,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar todos os relatórios associados ao processo e a unidadeGerencia:', error);
    throw error;
  }
};

export const GetByIdRelatorio = async (id) => {
  try {
    const response = await api.get(`Relatorio/${id}`);
    return response.data;
  } catch (error) {
    console.error('Erro ao buscar relatórios:', error);
    throw error;
  }
};

export default {
  SaveRelatorioSharepoint,
  DeleteRelatorio,
  GetByIdRelatorio,
  GetAllRelatorios,
  GetAllRelatoriosByIdProcessoAndIdUnidadeGerencia
};